import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const HistoryIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\ue889'}</MuiIcon>
        );
    })